import { Flex, Layout } from 'antd'
import React, { ReactNode } from 'react'
import logoLarge from '../../assets/logo-large.png'
import { useAuth } from '../../auth'
import { Container } from './container'
import { NotVerifiedAlert } from '../../user/components/not-verified-alert'
import { Link } from '@tanstack/react-router'

const { Content } = Layout

export type SimpleLayoutProps = { children: ReactNode }

export function SimpleLayout({ children }: SimpleLayoutProps) {
    const { user } = useAuth()

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Content>
                <Container>
                    <Flex
                        justify="space-between"
                        align="center"
                        className="mb-6 mt-6 gap-4 border-b border-hairline pb-4 flex-col xl:flex-row xl:gap-0"
                    >
                        <Link
                            to="/dashboard"
                            className="flex h-9 items-center"
                        >
                            <img
                                alt="logo"
                                className="shrink-0"
                                width="150"
                                src={logoLarge}
                            />
                        </Link>
                        {user && !user.emailVerifiedAt && <NotVerifiedAlert user={user} />}
                    </Flex>
                    {children}
                </Container>
            </Content>
        </Layout>
    )
}
